"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ENV_CONFIG_DELETE_BGWORK_SESSION = exports.API_ENV_CONFIG_SET_FTP_USER = exports.API_ENV_CONFIG_FETCH = void 0;
var API_ENV_CONFIG_FETCH;
(function (API_ENV_CONFIG_FETCH) {
    API_ENV_CONFIG_FETCH.PATH = '/env-config/fetch';
    API_ENV_CONFIG_FETCH.PURPOSE = '환경설정값 조회';
})(API_ENV_CONFIG_FETCH = exports.API_ENV_CONFIG_FETCH || (exports.API_ENV_CONFIG_FETCH = {}));
var API_ENV_CONFIG_SET_FTP_USER;
(function (API_ENV_CONFIG_SET_FTP_USER) {
    API_ENV_CONFIG_SET_FTP_USER.PATH = '/env-config/set-ftp-user';
    API_ENV_CONFIG_SET_FTP_USER.PURPOSE = 'CAFE24 FTP 연결정보 업데이트';
})(API_ENV_CONFIG_SET_FTP_USER = exports.API_ENV_CONFIG_SET_FTP_USER || (exports.API_ENV_CONFIG_SET_FTP_USER = {}));
var API_ENV_CONFIG_DELETE_BGWORK_SESSION;
(function (API_ENV_CONFIG_DELETE_BGWORK_SESSION) {
    API_ENV_CONFIG_DELETE_BGWORK_SESSION.PATH = '/env-config/delete-bgwork-session';
    API_ENV_CONFIG_DELETE_BGWORK_SESSION.PURPOSE = 'CAFE24 백그라운드 작업용 세션 삭제';
})(API_ENV_CONFIG_DELETE_BGWORK_SESSION = exports.API_ENV_CONFIG_DELETE_BGWORK_SESSION || (exports.API_ENV_CONFIG_DELETE_BGWORK_SESSION = {}));
//# sourceMappingURL=api-env-config.js.map